import React from "react";
import { Routes, Route } from "react-router-dom";

// Home
import Home from "./components/pages/Home";
import AboutUs from "./components/pages/AboutUs";
import Team from "./components/pages/Team";
import Wattshappening from "./components/pages/Wattshappening";
import Behindthescenes from "./components/pages/Behindthescenes";



// contact
import Contact from "./components/pages/Contact";


// Business


// E-Waste


// News / Blogs
import Blogs from "./components/blogs/Blogs";
import WhatHappenedWithTeslaIndia from "./components/blogs/WhatHappenedWithTeslaIndia";
import Isbatteryswappingaviablesolutionforindia from "./components/blogs/Isbatteryswappingaviablesolutionforindia";
import Isolaelectricambitionsforevsinindiaflawed from "./components/blogs/Isolaelectricambitionsforevsinindiaflawed";
import Electricvehicletrendsinindiaandtopsellingevsin2021 from "./components/blogs/Electricvehicletrendsinindiaandtopsellingevsin2021";
import Hownaturalgasutilitiesplayaroleinthefutureofourenergysystem from "./components/blogs/Hownaturalgasutilitiesplayaroleinthefutureofourenergysystem";
import Whatisthedealwithevscatchingfireandwhyshouldyoucare from "./components/blogs/Whatisthedealwithevscatchingfireandwhyshouldyoucare";
import Worldsfirstelectrifiedvintage1954fiatmillecento  from "./components/blogs/Worldsfirstelectrifiedvintage1954fiatmillecento ";
import Theeuropeanleadbatteryconferenceandexhibitionisliveandonline  from "./components/blogs/Theeuropeanleadbatteryconferenceandexhibitionisliveandonline";
import Thesurgeinelectrificationoftransportationrequiresasustainableandresilientelectricalinfrastructure  from "./components/blogs/Thesurgeinelectrificationoftransportationrequiresasustainableandresilientelectricalinfrastructure";
import Whywemustunlockenergysdnatoenableagreentransitionure  from "./components/blogs/Whywemustunlockenergysdnatoenableagreentransition";
import Buildbackbetterwithenergyefficiencyimprovements  from "./components/blogs/Buildbackbetterwithenergyefficiencyimprovements";
import Winnersofafsiasolarawardsannounced  from "./components/blogs/Winnersofafsiasolarawardsannounced";
import Howgreenareelectriccars  from "./components/blogs/Howgreenareelectriccars";


// Conversations / EV Episodes

import ConversationsPage from "./components/conversations/Conversationspage";
import EpisodesPodcast from "./components/conversations/EpisodesPodcast";
import EvEpisodes from "./components/conversations/EvEpisodes";
import Batteryepisodes from "./components/conversations/Batteryepisodes";
import Hydrogenepisodes from "./components/conversations/Hydrogenepisodes";



import Ep69 from "./components/conversations/Ep69vijaygokhale";
import Ep68 from "./components/conversations/Ep68kartikeyahariyani";

import Ep67 from "./components/conversations/Ep67pramitpalchaudhuri";

import Ep66 from "./components/conversations/Ep66zohramutabanna";
import Ep65 from "./components/conversations/Ep65sudhakarchirra";
import Ep64 from "./components/conversations/Ep64puneetanand";
import Ep63 from "./components/conversations/Ep63udaynarang";
import Ep62 from "./components/conversations/Ep62PeterVarghese";
import Ep61 from "./components/conversations/Ep61monteksingh";
import Ep60 from "./components/conversations/Ep60thirumalainc";
import Ep59 from "./components/conversations/Ep59womenleadershydrogen";
import Ep58 from "./components/conversations/Ep58philipgreen";
import Ep57 from "./components/conversations/Ep57vijaygokhale";
import Ep56 from "./components/conversations/Ep56ranjitkulkarni";
import Ep55 from "./components/conversations/Ep55amitabhkant";
import Ep54 from "./components/conversations/Ep54pratikgupta";
import Ep53 from "./components/conversations/Ep53shardulkulkarni";
import Ep52 from "./components/conversations/Ep52udaynarang";
import Ep51 from "./components/conversations/Ep51sudhirmehta";
import Ep50 from "./components/conversations/Ep50vijaygokhale";
import Ep49 from "./components/conversations/Ep49evchargeroems";
import Ep48 from "./components/conversations/Ep48amararaja";
import Ep47 from "./components/conversations/Ep47emotorad";
import Ep46 from "./components/conversations/Ep46akshaysinghal";
import Ep45 from "./components/conversations/Ep45sheetanshutyagi";
import Ep44 from "./components/conversations/Ep44lucafontanelli";
import Ep43 from "./components/conversations/Ep43rohansharvan";


import Ep42 from "./components/conversations/Ep42siddharthmayur";
import Ep41 from "./components/conversations/Ep41manishjain";
import Ep40 from "./components/conversations/Ep40vasudhamadhavan";
import Ep39 from "./components/conversations/Ep39ranjitaravi";



import Ep38 from "./components/conversations/Ep38amararajabatteries";
import Ep37 from "./components/conversations/Ep37fyn";
import Ep36 from "./components/conversations/Ep36vayvemobility";
import Ep35 from "./components/conversations/Ep35vasudhamadhavan";
import Ep34 from "./components/conversations/Ep34kapilshelke";
import Ep33 from "./components/conversations/Ep33greenhydrogen";
import Ep32 from "./components/conversations/Ep32mg";
import Ep31 from "./components/conversations/Ep31evsuperuser";
import Ep30 from "./components/conversations/Ep30chargepointoperators";
import Ep29 from "./components/conversations/Ep29ravipanga";
import Ep28 from "./components/conversations/Ep28preetibajaj";
import Ep27 from "./components/conversations/Ep27awadeshjha";
import Ep26 from "./components/conversations/Ep26karthikeyanpalanisamy";
import Ep25 from "./components/conversations/Ep25vijayvaitheeswaran";
import Ep24 from "./components/conversations/Ep24dhawalkhullar";
import Ep23 from "./components/conversations/Ep23udaynarang";
import Ep22 from "./components/conversations/Ep22gulpanagsudhirnayak";
import Ep21 from "./components/conversations/Ep21arunvinayak";
import Ep20 from "./components/conversations/Ep20kartikeyhariyani";
import Ep19 from "./components/conversations/Ep19cyrusdhabhar";
import Ep18 from "./components/conversations/Ep18rajeevchaba";
import Ep17 from "./components/conversations/Ep17krjyothilal";
import Ep15 from "./components/conversations/Ep15sajidmubashir";
import Ep14 from "./components/conversations/Ep14nishantarya";
import Ep16 from "./components/conversations/Ep16alishasachdev";
import Ep13 from "./components/conversations/Ep13jamesquinn";

import Ep12 from "./components/conversations/Ep12chargezone";
import Ep11 from "./components/conversations/Ep11gauravgupta";
import Ep10 from "./components/conversations/Ep10heroelectric";
import Ep09 from "./components/conversations/Ep09nexuspower";
import Ep08 from "./components/conversations/Ep08evconsumer";
import Ep07 from "./components/conversations/Ep07rejikumarpillai";
import Ep06 from "./components/conversations/Ep06maheshbabu";
import Ep05 from "./components/conversations/Ep05gigafactoriesfireside";
import Ep04 from "./components/conversations/Ep04sulajjafirodia";
import Ep03 from "./components/conversations/Ep03tarunmehta";
import Ep02 from "./components/conversations/Ep02stefanlouis";
import Ep01 from "./components/conversations/Ep01maxonlewis";
import WattsHappening from "./components/pages/Wattshappening";











function AppRoutes() {
  return (
    <Routes>

      {/* ── HOME ── */}
      <Route path="/" element={<Home />} />
       <Route path="/about-us" element={<AboutUs />} />
       <Route path="/our-team" element={<Team/>} />
       <Route path="/watts-happening/" element={<WattsHappening/>} />
       <Route path="/behind-the-scenes/" element={<Behindthescenes/>} />


       {/* Contact */}
       <Route path="/contact" element={<Contact/>} />



       {/* Blogs */}
       <Route path="/blog" element={<Blogs/>} />
       <Route path="/blog/what-happened-with-tesla-india" element={<WhatHappenedWithTeslaIndia/>} />
       <Route path="/blog/is-battery-swapping-a-viable-solution-for-india" element={<Isbatteryswappingaviablesolutionforindia/>} />
       <Route path="/blog/is-ola-electrics-ambitions-for-evs-in-india-flawed/" element={<Isolaelectricambitionsforevsinindiaflawed/>} />
       <Route path="/blog/electric-vehicle-trends-in-india-and-top-selling-manufactures-in-2021/" element={<Electricvehicletrendsinindiaandtopsellingevsin2021/>} />
       <Route path="/blog/how-natural-gas-utilities-play-a-role-in-the-future-of-our-energy-system/" element={<Hownaturalgasutilitiesplayaroleinthefutureofourenergysystem/>} />
       <Route path="/blog/what-is-the-deal-with-evs-catching-fire-and-why-should-you-care/" element={<Whatisthedealwithevscatchingfireandwhyshouldyoucare/>} />
       <Route path="/blog/worlds-first-electrified-vintage-1954-fiat-millecento/" element={<Worldsfirstelectrifiedvintage1954fiatmillecento/>} />
       <Route path="/blog/the-european-lead-battery-conference-exhibition-is-live-and-online-22-24-september/" element={<Theeuropeanleadbatteryconferenceandexhibitionisliveandonline/>} />
       <Route path="/blog/the-surge-in-electrification-of-transportation-requires-a-sustainable-and-resilient-electrical-infrastructure/" element={<Thesurgeinelectrificationoftransportationrequiresasustainableandresilientelectricalinfrastructure/>} />
       <Route path="/blog/why-we-must-unlock-energys-dna-to-enable-a-green-transition/" element={<Whywemustunlockenergysdnatoenableagreentransitionure/>} />
       <Route path="/blog/build-back-better-with-energy-efficiency-improvements/" element={<Buildbackbetterwithenergyefficiencyimprovements/>} />
       <Route path="/blog/winners-of-afsia-solar-awards-announced/" element={<Winnersofafsiasolarawardsannounced/>} />
       <Route path="/blog/how-green-are-electric-cars/" element={<Howgreenareelectriccars/>} />

       {/* Conversations / EV Episodes  */}
       <Route path="/conversations/" element={<ConversationsPage/>} />
       <Route path="/all-episodes/" element={<EpisodesPodcast/>} />

       <Route path="/ev/" element={<EvEpisodes/>} />
       <Route path="/battery/" element={<Batteryepisodes/>} />
       <Route path="/hydrogen/" element={<Hydrogenepisodes/>} />
       <Route path="/ep-69-oil-war-and-the-rupee-vijay-gokhale-on-what-global-turmoil-means-for-india" element={<Ep69/>} />
       <Route path="/ep-68-indias-ev-charging-story-is-entering-its-toughest-phase-execution-kartikeya-hariyani-founder-ceo-of-chargezone" element={<Ep68/>} />
       <Route path="/ep-67-geopolitics-has-returned-to-the-centre-of-the-energy-conversation-pramit-pal-chaudhuri" element={<Ep67/>} />
       <Route path="/ep-66-designing-cities-for-people-not-just-cars-rethinking-urban-mobility-with-zohra-mutabanna" element={<Ep66/>} />
       <Route path="/ep-65-freshbus-driving-indias-intercity-travel-electric-sudhakar-chirra" element={<Ep65/>} />
       <Route path="/ep-64-under-the-hood-hyundais-clean-mobility-journey-with-puneet-anand" element={<Ep64/>} />
      <Route path="/ep-63-remaining-indias-mobility-future-a-visionary-talk-with-uday-narang" element={<Ep63/>} />
      <Route path="/ep-62-peter-varghese-on-chinas-tech-dominance-trumps-america-the-india-australia-partnership" element={<Ep62/>} />
       <Route path="/ep-61-1991-indias-near-default-moment-how-did-we-survive-and-in-2025-what-challenges-come-next-montek-singh-ahluwalia" element={<Ep61/>} />
       <Route path="/ep60bangalorepollution/" element={<Ep60/>} />
       <Route path="/ep59womenleaderinhydrogen/" element={<Ep59/>} />
       <Route path="/ep58philipgreen/" element={<Ep58/>} />
       <Route path="/ep57vijayfhokhalegeo/" element={<Ep57/>} />
       <Route path="/ep56honeywellranjitkulkarni/" element={<Ep56/>} />
       <Route path="/ep-55-inside-indias-journey-towards-energy-transition-with-amitabh-kant/" element={<Ep55/>} />
       <Route path="/ep-54-decoding-the-future-of-urban-electric-mobility-gensol-ev-pratik-gupta/" element={<Ep54/>} />
       <Route path="/ep-53-industrial-decarbonisation-with-green-hydrogen-shardul-kulkarni/" element={<Ep53/>} />
       <Route path="/ep-52-empowering-sustainable-last-mile-deliveries-uday-narang/" element={<Ep52/>} />
       <Route path="/ep-51-revolutionizing-indias-buses-a-startups-electric-impact-sudhir-mehta-eka-pinnacle-industries/" element={<Ep51/>} />
       <Route path="/ep-50-unwrapping-geopolitics-with-vijay-gokhale/" element={<Ep50/>} />
       <Route path="/ep-49-ev-charger-oems-3-different-journeys-tirex-chargers-siemens-quench/" element={<Ep49/>} />
       <Route path="/ep-48-what-is-the-future-of-lead-acid-batteries-amara-raja-energy-mobility/" element={<Ep48/>} />
       <Route path="/ep-47-can-electric-cycles-become-a-part-of-our-everyday-lives-emotorad/" element={<Ep47/>} />
       <Route path="/ep-46-breaking-down-batteries-with-log9-akshay-singhal/" element={<Ep46/>} />
       <Route path="/ep-45-rediscovering-the-basics-of-batteries-with-emo-energy-sheetanshu-tyagi/" element={<Ep45/>} />
       <Route path="/ep-44-decentralizing-power-taking-ev-chargers-off-the-grid-e-gap-luca-fontanelli/" element={<Ep44/>} />
      <Route path="/ep-43-a-deep-dive-into-electric-trucks-tresa-motors-rohan-sharvan" element={<Ep43/>} />

       <Route path="/ep-42-the-abcs-of-green-hydrogen-h2e-power-siddharth-mayur/" element={<Ep42/>} />
       <Route path="/ep-41-shaadi-com-to-evs-chat-with-a-ev-super-user-manish-jain/" element={<Ep41/>} />
       <Route path="/ep-40-finding-investors-through-the-funding-winter-vasudha-madhavan/" element={<Ep40/>} />
       <Route path="/ep-39-can-electric-be-more-ta-fun-orxa-energies-ranjita-ravi" element={<Ep39/>} />
       <Route path="/ep-38-taking-the-bull-by-the-horns-legacy-takes-the-future-head-on-amara-raja-batteries/" element={<Ep38/>} />
       <Route path="/ep-37-rediscovering-sustainable-last-mile-logistics-fyn/" element={<Ep37/>} />
       <Route path="/ep-36-decoding-solar-powered-urban-mobility-vayve-mobility/" element={<Ep36/>} />
       <Route path="/ep-35-financing-your-ev-start-up-vasudha-madhavan/" element={<Ep35/>} />           
       <Route path="/ep-34-revolutionizing-the-electric-experience-an-inside-look-at-torks-vision-kapil-shelke/" element={<Ep34/>} />
       <Route path="/ep-33-decarbonizing-the-future-exploring-small-scale-off-grid-generation-of-green-hydrogen/" element={<Ep33/>} />
       <Route path="/ep-32-navigating-the-new-urban-jungle-mg-may-have-a-plan/" element={<Ep32/>} />       
       <Route path="/ep-31-driving-into-the-future-a-conversation-with-an-ev-super-user/" element={<Ep31/>} />
       <Route path="/the-chargepoint-operators-of-india-goec-charge-zone-zeon-chargemod/" element={<Ep30/>} />
       <Route path="/ep-29-sustainable-zero-emission-public-transport-for-india-ravi-panga-causis-group-ltd/" element={<Ep29/>} />
       <Route path="/ep-28-uncovering-indias-clean-energy-transition-preeti-bajaj-luminous-power-technologies/" element={<Ep28/>} />
       <Route path="/ep-27-concluding-the-chicken-egg-story-awadesh-jha-fortum-charge-drive-india/" element={<Ep27/>} />
       <Route path="/ep-26-electrifying-south-india-karthikeyan-palanisamy-zeon-charging/" element={<Ep26/>} />
       <Route path="/ep-25-decoding-chinas-dominance-on-evs-globally-the-economist-vijay-vaitheeswaran/" element={<Ep25/>} />
       <Route path="/ep-24-building-indias-first-homegrown-premium-electric-car-pravaig-dynamics-dhawal-khullar/" element={<Ep24/>} />
       <Route path="/ep-23-the-power-behind-real-sustainable-last-mile-deliveries-omega-seiki-mobility-uday-narang/" element={<Ep23/>} />
       <Route path="/ep-22-making-evs-mainstream-sunfuel-electric-gul-panag-sudhir-nayak/" element={<Ep22/>} />
       <Route path="/ep-21-achieving-the-impossible-rapid-charge-in-15-minutes-arun-vinayak-exponent-energy/" element={<Ep21/>} />
       <Route path="/ep-20-electrifying-indian-highways-kartiey-hariyani-chargezone/" element={<Ep20/>} />
       <Route path="/ep-19-what-are-the-ev-manufacturers-doing-wrong-cyrus-dhabar-powerdrift/" element={<Ep19/>} />
       <Route path="/e18-are-evs-truly-100-clean-mobility-rajeev-chaba-mg-motor-india/" element={<Ep18/>} />    
       <Route path="/e17-what-does-it-take-to-build-indias-most-electrified-state-k-r-jyothilal-ias/" element={<Ep17/>} />
       <Route path="ep-16-does-china-control-the-indian-e-mobility-sector-alisha-sachdev-cnbc-tv-18/" element={<Ep16/>} />
       <Route path="/ep15-exploring-the-rd-roadmap-of-evs-in-india-sajid-mubasir-ministry-of-science-technology/" element={<Ep15/>} />
       <Route path="/e-14-buses-of-the-future-changing-how-india-gets-to-work-jbm/" element={<Ep14/>} />
      <Route path="/e12-which-comes-first-the-infrastructure-or-the-evs-chargezone/" element={<Ep12/>} />
      <Route path="/ep-13-a-world-beyond-lithium-faradian" element={<Ep13/>} />
       <Route path="/e11-electrifying-an-automotive-icon/" element={<Ep11/>} />
       <Route path="/e10-the-hero-of-evs-hero-electric-pvt-ltd/" element={<Ep10/>} />
       <Route path="/e09-electric-vehicles-powered-by-farm-waste-nexus-power/" element={<Ep09/>} />
       <Route path="/e08-candid-conversation-with-a-significant-ev-consumer-on-his-1500km-adventure/" element={<Ep08/>} />
       <Route path="/e07-candid-conversation-with-reji-kumar-pillai-president-of-india-smart-grid-forum-on-charging-standards-in-india-the-power-grids-ability-to-accommodate-a-massive-move-to-e-mobility/" element={<Ep07/>} />
       <Route path="/e06-candid-conversation-with-mahesh-babu-md-ceo-at-mahindra-electric-mobility-ltd-on-their-plans-to-sell-500000-evs-in-india/" element={<Ep06/>} />
       <Route path="/e05-fireside-chat-with-industry-leaders-on-what-will-happen-when-the-gigafactories-arrive-in-india/" element={<Ep05/>} />
       <Route path="e04-candid-conversation-with-sulajja-firodia-motwani-founder-ceo-at-kinetic-green-energy-on-achieving-the-electric-dream-in-india/" element={<Ep04/>} />
       <Route path="/e03-candid-conversation-with-tarun-mehta-co-founder-ceo-at-ather-energy-on-his-journey-to-launch-a-game-changing-electric-scooter-whilst-raising-135m-along-the-way/" element={<Ep03/>} />
       <Route path="/e02-candid-conversation-with-stefan-louis-ceo-of-nexcharge-on-the-evolution-of-lithium-industry-in-india/" element={<Ep02/>} />
       <Route path="/candid-conversation-with-maxon-lewis/" element={<Ep01/>} />















































      
       


      




       

      {/* ── POWER & SURVEILLANCE ── */}
      {/* <Route path="/business/power-surveillance/hp-series"                                    element={<HpSeries />} />
      <Route path="/business/power-surveillance/prime-master-series"                          element={<PrimeMasterSeries />} />
      <Route path="/business/power-surveillance/liferaft-modular"                             element={<LiferaftModular />} />
      <Route path="/business/power-surveillance/power-plus-series"                            element={<PowerPlusSeries />} />
      <Route path="/business/power-surveillance/liferaft"                                     element={<Liferaft />} />
      <Route path="/business/power-surveillance/star-tx-series"                               element={<StarTxSeries />} />
      <Route path="/business/power-surveillance/star-plus-series"                             element={<StarPlusSeries />} />
      <Route path="/business/power-surveillance/star-plus-series-microcontroller-stabilizers" element={<StarPlusMicrocontroller />} /> */}

      {/* ── NEWS / BLOGS ── */}
      
    </Routes>
  );
}

export default AppRoutes;